import { render, staticRenderFns } from "./PurchaseOrderList.vue?vue&type=template&id=606cee72&"
import script from "./PurchaseOrderList.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderList.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderList.vue?vue&type=style&index=0&id=606cee72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports